import {
  usePopoverArrow
} from "../__chunks/SWPAMWUW.js";
import "../__chunks/GM7XQV7F.js";
import "../__chunks/6GS36SYX.js";
import {
  TooltipContext
} from "../__chunks/Z5BJMNGY.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/tooltip/tooltip-arrow.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useTooltipArrow = createHook(
  (_a) => {
    var _b = _a, { store, size = 16 } = _b, props = __objRest(_b, ["store", "size"]);
    const context = useContext(TooltipContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component"
    );
    props = usePopoverArrow(__spreadValues({ store, size }, props));
    return props;
  }
);
var TooltipArrow = createComponent((props) => {
  const htmlProps = useTooltipArrow(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  TooltipArrow.displayName = "TooltipArrow";
}
export {
  TooltipArrow,
  useTooltipArrow
};
